import React, { useEffect, useRef, useState } from "react";
import {
  TabContainer,
  ThankyouHeader,
  ThankyouMessage,
} from "../../components/SocialCaseTbas/Social.styled";
import { ComplaintContainer, Label } from "../complaint/Complaint.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import thanks from "../../assets/thanks.svg";
import complaintAndLinkStore, { RegisterComplaintRequest } from "../../stores/ComplaintAndLinkStore";
import General from "../../stores/GeneralStore";
import { useNavigate } from "react-router-dom";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import HappyMeterStore from "../../stores/HappyMeter";
import { Formik, Form, Field, ErrorMessage } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import User from "../../stores/UserStore";

import * as Yup from 'yup';
import { NotifyError } from "../../utils/ShowError";
const LinkProperty = () => {
  const key: string = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const [captchaToken, setCaptchaToken] = useState("");
  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
    const [captchareset, setCaptchareset] = useState(false);
  
  const [thankyou, setThankyou] = useState(false);
  const [isSearchApplied, setIsSearchApplied] = useState(false);
  const [parcelNumber, setParcelNumber] = useState<string>('');
  const [premiseDetails, setPremiseDetails] = useState<string>('');
  const [searchedPremiseId, setSearchedPremiseId] = useState<string>('');
  const [searchLoader, setSearchLoader] = useState(false);
  const [continueLoader, setContinueLoader] = useState(false);

  const handleSearch = async (values: any) => {
    if (!isRecaptchaVerified || !captchaToken) {
    NotifyError("Please verify reCAPTCHA");
    return;
  }
    setParcelNumber(values?.swerwge)

    setSearchLoader(true);  // Search Loader moved in condition
    try {
      let response = await complaintAndLinkStore.linkProperty(
        {
          errorId: 'linkPropertyError',
          data: {
            premiseId: values?.swerwge,
            recaptchaToken: captchaToken,
            platform: "Web"
          }
        })
       if (!response){
        setCaptchareset(true);
       }
      setPremiseDetails(response?.result?.premiseDetails);
      setSearchedPremiseId(values?.swerwge);
      setIsSearchApplied(true);
      setSearchLoader(false);
    } catch (error:any) {
      setCaptchareset(true);  
      setPremiseDetails('');
      setIsSearchApplied(false);
      setSearchLoader(false);
    }
  }
  useEffect(() => {
      if (captchareset) {
        recaptchaRef.current?.reset();
        setCaptchaToken("");
        setIsRecaptchaVerified(false);
        setCaptchareset(false); // 🔑 IMPORTANT
      }
    }, [captchareset]);

  const handleContinue = async (resetForm: any) => {
    setContinueLoader(true);

    try {
      if (searchedPremiseId && searchedPremiseId !== "") {
        const res = await complaintAndLinkStore.linkAccount({
          errorId: "linkAccountError",
          data: {
            premiseId: parcelNumber,
          },
        });
        if (res?.result?.message == "cm_linkaccountsuccess") {
          setThankyou(true);
          setSearchedPremiseId(searchedPremiseId)
          HappyMeterStore.openHappinessMeter();
          HappyMeterStore.setUPserviceID("11");
          setContinueLoader(false);
          resetForm()
        }
      }
      setContinueLoader(false);
      setIsSearchApplied(false);
      resetForm()
      setSearchedPremiseId('')
    } catch (error) {
      setContinueLoader(false);
      setSearchedPremiseId('')
    }
  };
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    swerwge: Yup.string().required(General?.codeLabels['cm_requirederr']?.label).matches(/^[0-9]+$/, General?.codeLabels['cm_numbererror']?.label).min(0, 'Minimum value must be 0')
      .max(10, 'Maximum value is 10'),

  });
  return (
    <>
      <MoveInHeader
        style={{
          color: General.contrast.contrastColor
            ? General.contrast.contrastColor
            : '#fff',
          background: General.contrast.contrastBackground
            ? General.contrast.contrastBackground
            : ColorAss === '#101E8E'? '#62aa51': General?.ColorAss
        }}
      >
        <div>
          <MiniNav>
            <ButtonSecondary
              style={{
                background: contrast?.contrastColor ? contrast?.contrastColor : "transparent",
                color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff",
                width: "81px",
                height: "30px",
                border: General?.ColorAss? "1px solid #FFF" :"",
              }}
              onClick={() => navigate(-1)}
            >
              {General?.codeLabels["cm_back"]?.label ? General?.codeLabels["cm_back"]?.label : "BACK"}
            </ButtonSecondary>
            {User?.info?.personId && <ButtonSecondary
              style={{
                background: contrast?.contrastColor ? contrast?.contrastColor : "transparent",
                color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff",
                width: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "12rem" : "117px",
                height: "30px",
                border: "1px solid #FFF",
              }}
              onClick={() => navigate("/dashboard")}
            >
              {General?.codeLabels["cm_dashboard"]?.label ? General?.codeLabels["cm_dashboard"]?.label : "DASHBOARD"}
            </ButtonSecondary>}
          </MiniNav>
          <h1 style={{
            fontFamily: "Segoe UI",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: General?.isLargeScreen ? `${3.1 * General.accessibility.fontSize}rem` : `${2 * General.accessibility.fontSize}rem`,
            margin: "0",
            color: contrast?.contrastColor ? contrast?.contrastColor : "",
            textTransform: 'capitalize'
          }}>{General?.codeLabels["cm_link"]?.label ? General?.codeLabels["cm_link"]?.label.toLowerCase() : "Link Property"}</h1>
        </div>
      </MoveInHeader>
      <ComplaintContainer
        style={{
          minHeight: thankyou ? "" : "60vh",
          marginTop: thankyou ? "1rem" : "auto",
          color: contrast?.contrastColor ? contrast?.contrastColor : '',
          background: contrast?.contrastBackground ? contrast?.contrastBackground : '',
          width: General?.isLargeScreen ? "" : "100%",
          padding: General?.isLargeScreen ? '' : "0rem 1rem"
        }}
      >
        {!thankyou && (
          <TabContainer style={{ width: General?.isLargeScreen ? "80%" : "100%", marginTop: General?.isLargeScreen ? "50px" : "1rem", display: General?.isLargeScreen ? "grid" : "flex", flexDirection: General?.isLargeScreen ? "row" : "column" }}>
            {" "}
            <Formik
              initialValues={{
                swerwge: '',


              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                handleSearch(values)
                setTimeout(() => {
                  // alert(JSON.stringify(values, null, 2));
                  setSubmitting(false);
                }, 400);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                resetForm,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                  <Label className="InsideNocText" style={{ color: contrast?.contrastColor ? contrast?.contrastColor : '', fontWeight: "700", fontSize: "16px", fontStyle: "normal", lineHeight: "16px" }}>

                    <span style={{
                      marginBottom: '0.2rem',
                      color: General.contrast.contrastBackground
                        ? General.contrast.contrastColor
                        : General?.ColorAss,
                    }}> {General?.codeLabels["cm_premiseid"]?.label !== undefined ? General?.codeLabels["cm_premiseid"]?.label : "Sewerage number"} </span>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: General?.isLargeScreen ? "row" : "column",
                        alignItems: "center",
                        width: "100%",
                        gap: "1.5rem",
                      }}
                    >
                      <Field
                        type="text"
                        name="swerwge"
                        style={{
                          paddingLeft: ".3rem",
                          width: General?.isLargeScreen ? "317px" : "100%",
                          height: "50px",
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastBackground
                            : General?.ColorAss,
                          background: General.contrast.contrastBackground
                            ? General.contrast.contrastColor
                            : "#fff",
                        }}

                      />
                      <ButtonSecondary
                        style={{

                          width: General?.isLargeScreen ? "179px" : "100%",
                          height: "50px",
                          zIndex: "0",
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastBackground
                            : '#fff',
                          background: General.contrast.contrastBackground
                            ? General.contrast.contrastColor
                            : General?.ColorAss,
                          border: "none"
                        }}
                        // onClick={handleSearch}
                        type="submit"
                      //className="InsideNocButton"
                      >

                        {searchLoader ? <Spinner width="30px" height="30px" /> : General?.codeLabels["cm_search"]?.label !== undefined ? General?.codeLabels["cm_search"]?.label : "SEARCH"}

                      </ButtonSecondary>
                    </div>
                      <div
                      style={{
                      marginTop: "16px",
                      display: "flex",
                      justifyContent: "flex-start",
                      }}>
               <ReCAPTCHA
                sitekey={key}
                ref={recaptchaRef}
                onChange={(response) => {
                if (response) {
                    setCaptchaToken(response);
                    setIsRecaptchaVerified(true);
                // setAttempts(0);
                 }
               }}
              onExpired={() => setIsRecaptchaVerified(false)}

              />

            </div>
                  </Label>
                  <Label>
                    <ErrorMessage
                      name="swerwge"
                      component="div"
                      className="error-message"
                    />
                  </Label>

                  {isSearchApplied && <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                      height: "10vh",
                    }}
                  >
                    <span //className="InsideNocText" 
                      style={{
                        fontWeight: "700",
                        fontStyle: "normal",
                        fontSize: "16px",
                        fontFamily: "Segoe UI",
                        paddingRight: "40PX",
                        color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss
                      }}>
                      {General?.codeLabels['cm_propertydet']?.label}</span>

                    <span
                      style={{
                        fontStyle: "normal",
                        fontSize: "16px",
                        fontFamily: "Segoe UI",
                        color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss
                      }}> {premiseDetails}</span>
                  </span>}
                  <p style={{
                    fontWeight: "400",
                    fontStyle: "normal",
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontFamily: "Segoe UI",
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                      marginTop:"30px"
                  }}>
                    {General?.codeLabels["cm_linkmessage"]?.label !== undefined ? General?.codeLabels["cm_linkmessage"]?.label : "**Note: Only accounts registered as tenant in Ajman Sewerage system can be linked"}
                  </p>
                  <hr style={{ gridColumn: "1 / span 2", width: "100%", backgroundColor: "#B6BFDC" }} />
                  <ButtonSecondary
                    style={{
                      color: General.contrast.contrastColor
                        ? General.contrast.contrastBackground
                        : '#fff',
                      background: General.contrast.contrastBackground
                        ? General.contrast.contrastColor
                        : General?.ColorAss,
                      width: General?.isLargeScreen ? "60%" : "100%",
                      padding: "10px 0",
                      opacity: !isSearchApplied ? '0.5' : '1',
                      marginBottom : isSearchApplied ? "1rem" : "0rem"
                    }}
                    disabled={!isSearchApplied}
                    onClick={() => handleContinue(resetForm)}
                    //className="InsideNocButton"
                    type="button"
                  >
                    {continueLoader ? <Spinner width="30px" height="30px" /> : General?.codeLabels["cm_continue"]?.label !== undefined ? General?.codeLabels["cm_continue"]?.label : "Continue"}
                  </ButtonSecondary>
                </form>
              )}
            </Formik>
          </TabContainer>
        )}
        {thankyou && (
          <TabContainer
            style={{
              width: General?.isLargeScreen ? '100%' : "100%",
              padding: "0",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              alignSelf: "flex-start",
              minHeight: "50vh",
              gap: "0",
              background: contrast?.contrastBackground ? contrast?.contrastBackground : 'white'
            }}
          >
            <ThankyouHeader
              style={{
                background: General.contrast.contrastBackground
                  ? General.contrast.contrastColor
                  : "rgba(98, 170, 81, 0.2)",

              }}

            >
              {/* <img src={thanks} alt="" /> */}
              <svg width="46" height="46" viewBox="0 0 46 46" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M23 0C10.317 0 0 10.317 0 23C0 35.683 10.317 46 23 46C35.683 46 46 35.683 46 23C46 18.44 44.6603 14.1893 42.3633 10.6113L40.9941 12.2285C42.8891 15.3825 44 19.06 44 23C44 34.579 34.579 44 23 44C11.421 44 2 34.579 2 23C2 11.421 11.421 2 23 2C28.443 2 33.3939 4.09977 37.1289 7.50977L38.4375 5.96484C34.3525 2.25984 28.935 0 23 0ZM41.2363 5.75391L21.9141 28.5547L13.7812 20.9688L12.418 22.4316L22.084 31.4473L42.7637 7.04688L41.2363 5.75391Z"
                  fill={General?.colorClass ? General?.colorClass : "#62AA51"} />
              </svg>

              <h1 style={{
                color: General.contrast.contrastColor
                  ? General.contrast.contrastBackground
                  : General?.ColorAss

              }}>
                {General?.codeLabels["cm_thankyou"]?.label !== undefined ? General?.codeLabels["cm_thankyou"]?.label : "Thank you !!!"}
              </h1>
            </ThankyouHeader>
            <ThankyouMessage>
              <p style={{
                color: General.contrast.contrastColor
                  ? General.contrast.contrastColor
                  : General?.ColorAss

              }}>
                {General?.codeLabels["cm_linkaccountsuccess"]?.label !== undefined ? General?.codeLabels["cm_linkaccountsuccess"]?.label : "Account is successfully link with portal"}
              </p>
              {/* <p >
                <b style={{
                  color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : General?.ColorAss

                }}>
                  {General?.codeLabels["cm_premiseid"]?.label !== undefined ? General?.codeLabels["cm_premiseid"]?.label : "Sewerage number"}

                </b>
              </p>
              <h4 style={{
                color: General.contrast.contrastColor
                  ? General.contrast.contrastColor
                  : General?.ColorAss
              }}>{searchedPremiseId}
              </h4> */}
              <ButtonSecondary
                //className={General?.colorClass}
                onClick={() => navigate("/dashboard")}
                style={{
                  marginTop: General?.isLargeScreen ? "4rem" : "0rem",
                  color: General.contrast.contrastColor
                    ? General.contrast.contrastBackground
                    : '#fff',
                  background: General.contrast.contrastBackground
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                  border: "none"
                }}>
                {General?.codeLabels["cm_back_to_dassh"]?.label ? General?.codeLabels["cm_back_to_dassh"]?.label : 'BACK TO DASHBOARD'}

              </ButtonSecondary>
            </ThankyouMessage>
          </TabContainer>
        )}
      </ComplaintContainer>
    </>
  );
};

export default LinkProperty;
